const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import styled from 'astroturf/react'
import { Button } from '@calendly/ui/components/button'

import TextField from 'components/form/text'
import _Centered from "styles-Centered.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/styles.js?styleId=Centered";
import _SubmitButton from "styles-SubmitButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/styles.js?styleId=SubmitButton";
import _Input from "styles-Input.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/styles.js?styleId=Input";
import _SecondaryInformation from "styles-SecondaryInformation.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/styles.js?styleId=SecondaryInformation";


export const Centered = /*#__PURE__*/styled('div', null, {
  displayName: "Centered",
  styles: _Centered
})

export const SubmitButton = /*#__PURE__*/styled(Button, null, {
  displayName: "SubmitButton",
  styles: _SubmitButton,
  attrs: props => ({
    ...props,
    wide: true,
    type: 'submit'
  })
})

export const Input = /*#__PURE__*/styled(TextField, null, {
  displayName: "Input",
  styles: _Input
})

export const SecondaryInformation = /*#__PURE__*/styled('div', null, {
  displayName: "SecondaryInformation",
  styles: _SecondaryInformation
})
